import { IOption } from "types/form.types";

export const getValueFromOptions = (
  options: IOption[],
  val: string | string[],
  multiple?: boolean
) => {
  // Xavfsizlik tekshiruvi: options array ekanligini tekshirish
  if (!Array.isArray(options)) {
    return multiple ? [] : null;
  }

  if (multiple) {
    const value = options?.filter((option) => val?.includes(option?._id));
    return value;
  }
  const value = options?.find((option) => option?._id === val);
  return value ? value : null;
};
